var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.05025 0.636155C1.65972 0.245631 1.02656 0.245631 0.636033 0.636155C0.245509 1.02668 0.245509 1.65984 0.636033 2.05037L5.58579 7.00012L0.636045 11.9499C0.245521 12.3404 0.245521 12.9736 0.636045 13.3641C1.02657 13.7546 1.65973 13.7546 2.05026 13.3641L7 8.41434L11.9497 13.3641C12.3403 13.7546 12.9734 13.7546 13.364 13.3641C13.7545 12.9736 13.7545 12.3404 13.364 11.9499L8.41421 7.00012L13.364 2.05037C13.7545 1.65984 13.7545 1.02668 13.364 0.636155C12.9734 0.245631 12.3403 0.245631 11.9498 0.636155L7 5.58591L2.05025 0.636155Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/IconClose.4d9948b6.svg";
export { ForwardRef as ReactComponent };